import React, { useState } from "react";
import "./immigration.css";
import InquiryForm from "../InquiryForm"; // ← your existing InquiryForm component

const FaqItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className={`imm-faq-item${open ? " open" : ""}`}>
      <button className="imm-faq-question" onClick={() => setOpen((p) => !p)}>
        {question}
        <span className="imm-faq-icon">+</span>
      </button>
      <div className="imm-faq-answer">{answer}</div>
    </div>
  );
};

const ImmigrationCanada = () => {
  const steps = [
    {
      title: "Fill In The Required Form",
      desc: "Complete our online application form with accurate personal, professional, and travel details to kick-start your Canadian visa process.",
    },
    {
      title: "Submit Your Original Documents",
      desc: "Provide certified copies of passports, qualifications, employment records, and other supporting documents as required by IRCC.",
    },
    {
      title: "Get The Visa Resource Material",
      desc: "Receive comprehensive guides, checklists, and expert tips to help you prepare for every stage of the Canadian immigration process.",
    },
  ];

  const benefits = [
    "Labore et dolore ipsum magna aliqua",
    "Ut enim veniam, quis nostrud minim exercitation",
    "Itation ullamco laboris nisiut aliquip irure",
    "Dolor in reprehenderit voluptate velit esse",
    "Cillum dolore fugiat nulla excepteur",
    "Sint occaecat cupidatat non proident",
  ];

  const faqs = [
    {
      question: "How long does it take for a Student Visa to process?",
      answer:
        "Processing times for a Canadian student visa (study permit) typically range from 4–12 weeks, depending on your country of application and the volume of applications. We strongly recommend applying at least 3–4 months before your program start date. Our consultants monitor your file and keep you informed at every milestone.",
    },
    {
      question: "What is the fee structure for visa submission?",
      answer:
        "The Canadian government charges a study permit application fee (currently CAD 150) plus biometrics if required. Our service fee covers a full eligibility assessment, document preparation, application lodgement, and follow-up. Contact our team for a transparent, tailored quote with no hidden charges.",
    },
    {
      question:
        "What are the important things to know as a Student Visa applicant?",
      answer:
        "You must hold a valid Letter of Acceptance (LOA) from a Designated Learning Institution (DLI), show proof of financial support, provide a clean background check, and demonstrate that you intend to leave Canada upon completion of your studies (unless you apply for a Post-Graduate Work Permit).",
    },
  ];

  return (
    <div className="imm-page">
      {/* ── HERO ── */}
      <section className="imm-hero">
        <span className="imm-hero-flag">🇨🇦</span>
        <h1>Study, Work &amp; Live in Canada</h1>
        <p className="imm-hero-sub">
          Sponsoring and managing work visas — turning your Canadian dream into
          a guaranteed, life-changing reality.
        </p>
        <span className="imm-hero-badge">🌎 Canada Immigration Services</span>
      </section>

      {/* ── STEPS ── */}
      <section className="imm-steps-wrap">
        <div className="imm-container">
          <span className="imm-section-tag">How It Works</span>
          <h2 className="imm-section-title">Your 3-Step Immigration Journey</h2>
          <p className="imm-section-sub">
            Nunc quam arcu, pretium quis quam sed, laoreet efficitur leo. Aliquam
            erat volutpat lobortis sem consequat imperdiet.
          </p>
          <div className="imm-steps">
            {steps.map((s, i) => (
              <div className="imm-step-card" key={i}>
                <div className="imm-step-num">{i + 1}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHY CANADA ── */}
      <section className="imm-why">
        <div className="imm-container">
          <div className="imm-why-inner">
            <div className="imm-why-text">
              <span className="imm-section-tag">About Canada</span>
              <h2 className="imm-section-title">Why Study in Canada?</h2>
              <p>
                Velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                occaecat cupidatat non proident, sunt in culpa qui officia deserunt
                mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus
                error sit voluptatem accusantium doloremque laudantium, totam rem
                aperiam, eaque ipsa quae ab illo inventore veritatis et quasi
                architecto beatae vitae dicta sunt explicabo.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
                ad minim veniam, quis nostrud exercitation ullamco laboris.
              </p>
            </div>

            <div>
              <span className="imm-section-tag">Visa Benefits</span>
              <h2 className="imm-section-title" style={{ marginBottom: 24 }}>
                Our Visa Benefits
              </h2>
              <ul className="imm-benefits-list">
                {benefits.map((b, i) => (
                  <li key={i}>
                    <span className="imm-bullet-dot" />
                    {b}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ── TEST PREP ── */}
      <section className="imm-prep">
        <div className="imm-container">
          <span className="imm-section-tag">Preparation</span>
          <h2 className="imm-section-title">How To Do Test Preparation</h2>
          <p className="imm-prep-body">
            Nunc quam arcu, pretium quis quam sed, laoreet efficitur leo. Aliquam
            erat volutpat lobortis sem consequat imperdiet. In nulla sed viverra ut
            lorem ut dapibus, estetur diam nunc bibendum imperdiet. Lorem ipsum
            dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
            incididunt ut labore et dolore magna aliqua.
          </p>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section className="imm-faq">
        <div className="imm-container">
          <span className="imm-section-tag">FAQs</span>
          <h2 className="imm-section-title">Frequently Asked Questions</h2>
          <div className="imm-faq-list">
            {faqs.map((f, i) => (
              <FaqItem key={i} question={f.question} answer={f.answer} />
            ))}
          </div>
        </div>
      </section>

      {/* ── INQUIRY FORM ── */}
      <InquiryForm title="Inquire About Immigration to Canada" />

    </div>
  );
};

export default ImmigrationCanada;